module.exports = __webpack_public_path__ + "static/media/logo.a2d7f9f1.png";